import React, { useCallback, useContext, useState } from 'react';

import Profile from './Profile';
import CurrentUserContext from '../../../contexts/CurrentUserContext';
import updateUser from '../../../api/updateUser';
import CloudFunctionClientContext from '../../../contexts/CloudFunctionClientContext';
import useUser from '../../../hooks/useUser';
import userTypeCheckers from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UsersProvider/userTypeCheckers';
import Loading from '../../Loading/Loading';
import ToastContext from '../../../contexts/ToastContext';

const ProfileContainer = ({
  currentUser,
}: {
  currentUser: UserManagement.SignedUpUser | UserManagement.FleetOpsStaffUser;
}) => {
  const { api } = useContext(CloudFunctionClientContext);
  const { showToast } = useContext(ToastContext);

  const [displayName, setDisplayName] = useState<string>(
    currentUser.displayName || '',
  );

  const onDisplayNameChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setDisplayName(event.target.value);
    },
    [],
  );

  const [isSaving, setIsSaving] = useState(false);
  const onSave = () => {
    setIsSaving(true);
    updateUser(
      currentUser.id,
      {
        displayName,
      },
      api,
    )
      .then((response) => {
        setIsSaving(false);
        if (response.ok) {
          showToast('Profile updated successfully');
        } else {
          showToast('Failed to update profile. Please try again.');
        }
      })
      .catch(() => {
        setIsSaving(false);
        showToast('Failed to update profile. Please try again.');
      });
  };

  return (
    <Profile
      onSave={onSave}
      isSaving={isSaving}
      displayName={displayName}
      onDisplayNameChanged={onDisplayNameChanged}
    />
  );
};

const Gate = () => {
  const currentUserContext = useContext(CurrentUserContext);
  const { user: currentUser, isLoading } = useUser(currentUserContext.id);

  if (isLoading) {
    return <Loading />;
  }

  if (!currentUser) {
    return null;
  }

  if (
    userTypeCheckers.isSignedUpUser(currentUser) ||
    userTypeCheckers.isFleetOpsStaffUser(currentUser)
  ) {
    return <ProfileContainer currentUser={currentUser} />;
  }

  return null;
};

export default Gate;
